import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import {
  changeDictionaries,
  courseTypeStsList,
  quelityTypeList,
  hostingTypeList
} from '@/utils/dictionary.js';
// 材料费类型
export const MATERIAL_TYPES = 512;

export const columns = [
  key('分账规则ID', 'configId', tableColumnsWidth.type4, {
    fixed: 'left'
  }),
  slot('分账规则名称', 'configName', tableColumnsWidth.type6, {
    fixed: 'left'
  }),
  // slot('监管平台', 'inAccountType', tableColumnsWidth.type9, {
  //   fixed: 'left'
  // }),
  slot('规则状态', 'isEnable', tableColumnsWidth.type2, {
    fixed: 'left'
  }),
  slot('监管银行', 'bankName', tableColumnsWidth.type2, {
    fixed: 'left'
  }),
  slot('手续费比例', 'wxRate', tableColumnsWidth.type9, {
    align: 'center'
  }),

  slot('分账业务类型', 'busiTypes', tableColumnsWidth.type6, {
    align: 'center'
  }),
  key('规则已关联商品数', 'relProdNum', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('配置机构数', 'relOrgNum', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('规则可见学校数', 'relSchNum', tableColumnsWidth.type9, {
    align: 'center'
  }),
  key('创建时间', 'createTime', tableColumnsWidth.type5),
  key('最新更新人', 'operatorName', tableColumnsWidth.type9),
  key('最新更新时间', 'operatorTime', tableColumnsWidth.type5),

  slot('操作', 'action', 310, {
    fixed: 'right',
    align: 'center'
  })
];
const quelityList = quelityTypeList.slice(1, quelityTypeList.length); // 课程类型-素质
const hostingList = hostingTypeList.slice(1, hostingTypeList.length); // 课程类型-托管
const map = {
  MATERIAL_TYPES: '材料费'
};
for (const k of quelityList) {
  map[k['value']] = k['label'];
}
for (const i of hostingList) {
  map[i['value']] = i['label'];
}
export function getBusiTypeNames(data) {
  const res = data.map((item) => {
    return map[item];
  });
  return res.join('、');
}

export function getAccountNames(inAccountType) {
  const enumObj = {
    1: '平安银行',
    2: '花都工行',
    3: '微信商户'
  };
  return enumObj[inAccountType];
}
